import PropTypes from 'prop-types';
import { useAppContext } from '../../../Services/AppContext';
import React, { useEffect, useLayoutEffect, useState } from 'react';
// @ts-ignore
import styles from './TextField.module.scss';
import { joinClasses } from '../../../Utils/className.util';
import Label from '../Label/Label';
import Text from '../Text/Text';
import { useValidation } from '../../Utils/Validation';
import { isString } from 'lodash';

function TextField({ forwardRef, selfValue = true, ...props }) {
	const [typingTimeout, setTypingTimeout] = useState(null);
	const { translation } = useAppContext();
	const { fillErrorMessage } = useValidation();
	const [value, setValue] = useState('');
	const [inputStyle, setInputStyle] = useState<object>({});
	const prefixId = 'prefix' + Math.random();

	useLayoutEffect(() => {
		const prefixWidth = document.getElementById(prefixId)?.clientWidth;
		if (prefixWidth) {
			setInputStyle({ paddingLeft: prefixWidth + 25 + 'px' });
		}
	}, [props.prefix]);

	const handleOnChange = e => {
		const val = e.target.value;

		if (selfValue) {
			setValue(val);
		}

		if (!props.bounce) {
			return props.onChange(val);
		}

		if (typingTimeout) {
			clearTimeout(typingTimeout);
		}

		setTypingTimeout(
			setTimeout(() => {
				props.onChange?.(val);
			}, props.bounce || 0),
		);
	};

	const handleOnFocus = e => {
		props.onFocus?.(e);
	};

	const handleOnClick = e => {
		props.onClick?.(e);
	};

	const placeholder = translation[props.placeholder] || props.placeholder;

	useEffect(() => {
		if (!isString(value)) {
			handleOnChange('');
		}
	}, [value]);

	useEffect(() => {
		if (props?.value != value) {
			setValue(isString(props?.value) ? props?.value : '');
		}
	}, [props?.value]);

	return (
		<div className={joinClasses([props.wrapperClassName, styles.wrapper])}>
			{props.label && <Label tx={props.label} firstUpper={props.firstUpper} />}
			{props.prefix && (
				<div className={styles.prefix} id={prefixId}>
					<Text tx={props.prefix} inline />
				</div>
			)}
			<input
				{...props}
				value={props?.value || (selfValue ? value : '')}
				disabled={props.disabled}
				placeholder={placeholder}
				style={inputStyle}
				onChange={handleOnChange}
				onBlur={handleOnChange}
				onClick={handleOnClick}
				onFocus={handleOnFocus}
				className={joinClasses([
					props.className,
					'form-control',
					styles.input,
					props.error ? styles.invalid : '',
					props.suffix ? styles.withSuffix : '',
				])}
				ref={forwardRef}
			/>
			{props.suffix && (
				<div className={styles.suffix}>
					<Text tx={props.suffix} inline={true} />
				</div>
			)}
			{props.error && (
				<div className={styles.errorMessage}>
					<Text tx={fillErrorMessage(props.error)} inline={true} />
				</div>
			)}
		</div>
	);
}

export default React.forwardRef((props, ref) => (
	<TextField {...props} forwardRef={ref} />
));

TextField.propTypes = {
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	placeholder: PropTypes.string,
	required: PropTypes.bool,
	value: PropTypes.string,
	bounce: PropTypes.number,
	label: PropTypes.string,
	firstUpper: PropTypes.bool,
	className: PropTypes.string,
	wrapperClassName: PropTypes.string,
	id: PropTypes.string,
	prefix: PropTypes.string,
	suffix: PropTypes.string,
	disabled: PropTypes.bool,
	selfValue: PropTypes.bool,
};
